var map = {
	"./remember-da-dk.avif": 82372,
	"./remember-de-de.avif": 5504,
	"./remember-en-gb.avif": 42656,
	"./remember-en-us.avif": 39792,
	"./remember-es-es.avif": 92188,
	"./remember-es-mx.avif": 83536,
	"./remember-fr-fr.avif": 90678,
	"./remember-it-it.avif": 83251,
	"./remember-nb-no.avif": 27865,
	"./remember-nl-nl.avif": 79057,
	"./remember-pl-pl.avif": 11064,
	"./remember-pt-br.avif": 13833,
	"./remember-pt-pt.avif": 65423,
	"./remember-sv-se.avif": 20400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55369;